import React from 'react';
import myPicture from '../images/myPicture1.jpg'

function Body({mode, language}) {

if (language === "English") {
  return (
    <div className={mode === ""? "body": `body${mode}`} id='body'>
        <div className='brief-description'>
            <img
            className='myImage'
            alt='my-self'
            src={myPicture}
            />
            <p className='text'>
              What's up! Felipe here, a tech enthusiast with strong foundation in Web Develoment using technologies such as Django Rest Frameworks and ReactJS (fetch/ajax) combining all my knowledge of JavaScript, HTML, CSS (with responsive media queries), Bootstrap, Node packages modules, etc.
            <br />
            <br />
              I have been enriching my journey by getting familiar with low-code development platforms like Flutterflow, where I had the chance to build and deploy Web and mobile applications using backend environments like Supabase and Firebase.
            <br />
            <br />
              However, I'm always eager to take on new challenges and contribute to exciting projects. Needless to say that I really enjoy applying these abilities to chase ideas and solutions and put them on a device screen.
            </p>
        </div>
        <div  id="work-line" className='separator'></div>
    </div>
  )
} else {
  return (
    <div className={mode === ""? "body": `body${mode}`} id='body'>
        <div className='brief-description'>
            <img
            className='myImage'
            alt='my-self'
            src={myPicture}
            />
            <p className='text'>
             ¡Hola! Soy Felipe, un entusiasta de la tecnología con una sólida formación en desarrollo web que utiliza tecnologías como Django Rest Frameworks y ReactJS (fetch/ajax), combinando todos mis conocimientos de JavaScript, HTML, CSS (con consultas de medios responsivas), Bootstrap, módulos de paquetes de Node, etc.
            <br />
            <br />
             He ido enriqueciendo mi recorrido familiarizándome con plataformas de desarrollo low-code como Flutterflow, donde tuve la oportunidad de construir e implementar aplicaciones web y móviles utilizando entornos backend como Supabase y Firebase.
           <br />
           <br />
             Siempre estoy dispuesto a asumir nuevos retos y contribuir a proyectos emocionantes. No hace falta decir que disfruto mucho aplicando estas habilidades para buscar ideas y soluciones y plasmarlas en la pantalla de un dispositivo.

            </p>
        </div>
        <div  id="work-line" className='separator'></div>
    </div>
  )
}
}

export default Body